export default "__VITE_ASSET__2879879d__"